import { Phone, MapPin, Mail, Facebook, Sparkles } from "lucide-react";
import Testimonials from "@/components/sections/Testimonials";

const LOGO = "https://customer-assets.emergentagent.com/job_austin-yard-pro/artifacts/h82kv0hn_IMG_4290.png";
const QR = "https://customer-assets.emergentagent.com/job_austin-yard-pro/artifacts/e7ga75vb_IMG_4297.jpeg";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61589893103496";

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer" className="bg-black border-t border-border">
      {/* Join the Ironclad community */}
      <div className="relative overflow-hidden border-b border-border">
        <div
          className="absolute inset-0 opacity-30 mix-blend-screen pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(ellipse at 30% 40%, rgba(127,176,105,0.35), transparent 60%), radial-gradient(ellipse at 75% 80%, rgba(127,176,105,0.15), transparent 65%)",
          }}
        />
        <div className="container-ic relative py-16 md:py-20 text-center">
          <div className="overline mb-4">
            <Sparkles className="inline h-3.5 w-3.5 mr-2 -mt-0.5" />
            Join The Ironclad Community
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tighter leading-[0.95] max-w-3xl mx-auto">
            We can't wait to <span className="text-primary">welcome you home.</span>
          </h2>
          <p className="mt-5 text-muted-foreground text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            More than mowing — it's a brotherhood of homeowners who take pride in their
            patch of Texas. First cut or fiftieth, you're not just hiring a service.
            You're stepping into the family.
          </p>
        </div>
      </div>

      {/* Compact testimonials slider before contact */}
      <Testimonials compact id="footer-testimonials" />

      <div className="container-ic py-20 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={LOGO}
              alt="Ironclad Yard Services"
              className="h-28 w-auto object-contain -ml-2"
              data-testid="footer-logo"
            />
            <p className="mt-5 text-sm text-muted-foreground max-w-sm">
              Veteran owned lawn care serving San Antonio and the greater surrounding area.
              Protecting your yard the Ironclad way.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Service Area</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>San Antonio, TX</li>
              <li>& Surrounding Cities</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4">Get In Touch</div>
            <a
              href="tel:5129480676"
              className="flex items-center gap-3 text-foreground hover:text-primary transition-colors mb-3"
              data-testid="footer-phone"
            >
              <Phone className="h-4 w-4" />
              <span className="font-display text-xl">512-948-0676</span>
            </a>
            <a
              href="mailto:ironcladatx@gmail.com"
              className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary mb-3"
              data-testid="footer-email"
            >
              <Mail className="h-4 w-4" />
              ironcladatx@gmail.com
            </a>
            <div className="flex items-center gap-3 text-sm text-muted-foreground mb-4">
              <MapPin className="h-4 w-4" />
              Central Texas
            </div>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 border border-border px-4 py-3 text-sm hover:border-primary hover:text-primary transition-colors"
              data-testid="footer-facebook"
            >
              <Facebook className="h-4 w-4" />
              <span>Follow on Facebook · Ironclad-ATX</span>
            </a>
          </div>
        </div>

        <div className="divider-line my-12" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5">
            <div className="font-display text-5xl md:text-7xl font-black tracking-tighter uppercase text-primary/15 leading-none select-none">
              IRONCLAD
            </div>
            <div className="mt-4 text-xs text-muted-foreground">
              © {new Date().getFullYear()} Ironclad Yard Services. All rights reserved.
            </div>
            <a
              href="/admin/login"
              className="inline-block mt-2 text-xs text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-admin-link"
            >
              Staff Login
            </a>
          </div>

          <div className="md:col-span-7">
            <div
              className="flex items-center gap-5 border border-border bg-card/40 p-5"
              data-testid="footer-qr-card"
            >
              <div className="bg-white p-2 flex-shrink-0">
                <img
                  src={QR}
                  alt="Scan to book Ironclad Yard Services"
                  className="w-28 h-28 md:w-32 md:h-32 object-contain"
                />
              </div>
              <div>
                <div className="overline mb-2">Scan To Book</div>
                <div className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight">
                  Point. Scan. Done.
                </div>
                <p className="text-sm text-muted-foreground mt-2 max-w-sm">
                  Snap this code with your camera to open Ironclad on your phone and
                  request your free estimate in under a minute.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
